import window from '../../../../../reuse/window/windowDefault'

export default window(
  'tiposendereco',
  'Tipos de Endereco',
  () => import('./WindowMain.vue'),
  function (props) {
    return props
  },
  {
    resolveCallback: function (wid) {
      console.log('Callback resolve', wid, this)
      this.$uloc.window.listen(wid, {
        update: (wid, val) => {
          console.log('Atualizado: ', val)
          this.updateList(val)
        }
      })
    },
    width: '500',
    height: '500',
  }
)
